import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import useSWR from "swr";
import { process } from "../../Process";
import { Auth0Fetcher } from "ee-react-components";
import { NOCControls } from "./NocControls";
export var NOCOrganizationControls = function () {
    var _a = useAuth0(), isAuthenticated = _a.isAuthenticated, isLoading = _a.isLoading, getAccessTokenSilently = _a.getAccessTokenSilently;
    var organizations = useSWR(isLoading || !isAuthenticated
        ? null
        : [
            "".concat(process.env.NOC_SVC_URL, "/organizations/listall"),
            getAccessTokenSilently,
        ], Auth0Fetcher).data;
    var merchantsOfRecord = useSWR(isLoading || !isAuthenticated
        ? null
        : [
            "".concat(process.env.NOC_SVC_URL, "/merchants-of-record/listall"),
            getAccessTokenSilently,
        ], Auth0Fetcher).data;
    var emspIntegrationConfigurations = useSWR(isLoading || !isAuthenticated
        ? null
        : [
            "".concat(process.env.NOC_SVC_URL, "/emsp-integration-configuration/listall"),
            getAccessTokenSilently,
        ], Auth0Fetcher).data;
    var paymentRestrictions = useSWR(isLoading || !isAuthenticated
        ? null
        : [
            "".concat(process.env.NOC_SVC_URL, "/payment-restriction/listall"),
            getAccessTokenSilently,
        ], Auth0Fetcher).data;
    var controllableAssets = [];
    if (organizations) {
        controllableAssets = controllableAssets.concat(organizations.map(function (o) {
            return {
                title: "Organization ".concat(o.name, " (ID: ").concat(o.id, ")"),
                metadataUrl: "/organizations/metadata/".concat(o.id),
                setMetadataUrl: "/organizations/metadata/set/".concat(o.id),
            };
        }));
    }
    if (merchantsOfRecord) {
        controllableAssets = controllableAssets.concat(merchantsOfRecord.map(function (mor) {
            var _a;
            return {
                title: "Merchant of Record ".concat(mor.merchantId, " in Org: ").concat(((_a = mor.organization) === null || _a === void 0 ? void 0 : _a.name) || "Unknown Org", " (ID: ").concat(mor.id, ")"),
                metadataUrl: "/merchants-of-record/metadata/".concat(mor.id),
                setMetadataUrl: "/merchants-of-record/metadata/set/".concat(mor.id),
            };
        }));
    }
    if (emspIntegrationConfigurations) {
        controllableAssets = controllableAssets.concat(emspIntegrationConfigurations.map(function (emspConfig) {
            return {
                title: "Emsp Integration Configuration ".concat(emspConfig.emspIntegration),
                metadataUrl: "/emsp-integration-configuration/metadata/".concat(emspConfig.emspIntegration),
                setMetadataUrl: "/emsp-integration-configuration/metadata/set/".concat(emspConfig.emspIntegration),
            };
        }));
    }
    if (paymentRestrictions) {
        controllableAssets = controllableAssets.concat(paymentRestrictions.map(function (pr) {
            var _a;
            return {
                title: "Payment Restriction for Org: ".concat(((_a = pr.organization) === null || _a === void 0 ? void 0 : _a.name) || "Unknown Org", " (ID: ").concat(pr.id, ")"),
                metadataUrl: "/payment-restriction/metadata/".concat(pr.id),
                setMetadataUrl: "/payment-restriction/metadata/set/".concat(pr.id),
            };
        }));
    }
    var siteParentConfig;
    if (organizations) {
        siteParentConfig = {
            possibleParents: organizations
                .sort(function (a, b) { return a.id - b.id; })
                .map(function (o) {
                return {
                    title: "".concat(o.name),
                    id: o.id,
                };
            }),
            title: "Parent Organization",
            key: "organizationId",
        };
    }
    var merchantOfRecordParentConfig;
    if (organizations) {
        merchantOfRecordParentConfig = {
            possibleParents: organizations
                .sort(function (a, b) { return a.id - b.id; })
                .map(function (o) {
                return {
                    title: "".concat(o.name),
                    id: o.id,
                };
            }),
            title: "Parent Organization",
            key: "orgId",
        };
    }
    var paymentRestrictionParentConfig;
    if (organizations) {
        paymentRestrictionParentConfig = {
            possibleParents: organizations
                .sort(function (a, b) { return a.id - b.id; })
                .map(function (o) {
                return {
                    title: "".concat(o.name),
                    id: o.id,
                };
            }),
            title: "Parent Organization",
            key: "organizationId",
        };
    }
    var creatableAssets = [
        {
            title: "Provision New Organization",
            createUrl: "/organizations/create",
            subObjects: [
                {
                    metadataUrl: "/organizations/metadata",
                },
            ],
        },
        {
            title: "Provision New Site",
            createUrl: "/sites/create",
            parent: siteParentConfig,
            subObjects: [
                {
                    metadataUrl: "/sites/metadata",
                    subObjectKey: "site",
                },
                {
                    metadataUrl: "/sites/address/metadata",
                    subObjectKey: "address",
                },
            ],
        },
        {
            title: "Provision New Merchants Of Record",
            createUrl: "/merchants-of-record/create",
            parent: merchantOfRecordParentConfig,
            subObjects: [
                {
                    metadataUrl: "/merchants-of-record/metadata",
                },
            ],
        },
        {
            title: "Provision New Emsp Integration Configuration",
            createUrl: "/emsp-integration-configuration/create",
            subObjects: [
                {
                    metadataUrl: "/emsp-integration-configuration/metadata",
                },
            ],
        },
        {
            title: "Provision New Payment Restriction",
            createUrl: "/payment-restriction/create",
            parent: paymentRestrictionParentConfig,
            subObjects: [
                {
                    metadataUrl: "/payment-restriction/metadata",
                },
            ],
        },
    ];
    return (React.createElement(NOCControls, { controllableAssets: controllableAssets, creatableAssets: creatableAssets }));
};
